module.exports = __webpack_public_path__ + "img/avatar-male.2feb3f71.jpeg";